const isMainSite = (): boolean => process.env.GATSBY_WP_URL === 'cms.drk-khs.de'

export default isMainSite

